module.exports = __webpack_public_path__ + "static/img/grua.3bb1e39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/grua.jpg
// module id = ZaZJ
// module chunks = 1